// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"27":"myapp-parent","352":"my-app-helloworld","450":"About"}[chunkId] + "." + {"27":"5f23d9e2","352":"2e918158","450":"64133be3"}[chunkId] + ".css";
};